import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Slider from "react-slick";
import HeaderTwo from "../parts/HeaderTwo";
import CafeNoteCard from "./CafeNoteCard";
import { GetCafeNotes200ResponseInner } from "../../../api/v1";
import { api } from "../../../api";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

type CafeNotesProps = {
  shopId?: number;
  backgroundColor?: string;
  ml?: string;
  mr?: string;
};

const CafeNotesStyle = styled.div<{
  $backgroundColor?: string;
  $ml?: string;
  $mr?: string;
}>`
  background: ${(props) => props.$backgroundColor || "white"};
  padding-top: 30px;
  padding-left: ${(props) => props.$ml || "30px"};
  padding-right: ${(props) => props.$mr || "30px"};
  padding-bottom: 50px;

  @media (max-width: 768px) {
    padding: 30px 10px 50px 10px;
  }
`;

const SlickCafeNoteImagesStyle = styled(Slider)`
  .slick-list {
    margin-right: -9px;
    padding-bottom: 20px;
  }

  .slick-slide > div > a {
    padding: 0 10px 10px 0;
  }
`;

const CafeNoteCardsSliderStyle = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;

  a {
    width: calc(25% - 10px);
  }

  @media (max-width: 767px) {
    a {
      width: calc(50% - 5px);
    }
  }
`;

const CafeNotes: React.FC<CafeNotesProps> = ({
  shopId,
  backgroundColor,
  ml,
  mr,
}) => {
  const settings = {
    adaptiveHeight: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "ease",
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          rows: 2,
        },
      },
    ],
  };
  const [cafeNotes, setCafeNotes] = useState<
    Array<GetCafeNotes200ResponseInner>
  >([]);

  useEffect(() => {
    api.getPublicCafeNotes(1, 4, shopId).then((response) => {
      setCafeNotes(response.data);
    });
  }, []);

  return (
    <CafeNotesStyle $ml={ml} $mr={mr} $backgroundColor={backgroundColor}>
      <HeaderTwo mb="20px">新着投稿のカフェノート</HeaderTwo>
      {cafeNotes.length > 4 ? (
        <SlickCafeNoteImagesStyle {...settings}>
          {cafeNotes.map((cafeNote, index) => {
            return (
              <CafeNoteCard
                key={index}
                cafeNote={cafeNote}
                link={`/user/public-cafe-notes/${cafeNote.id}`}
              />
            );
          })}
        </SlickCafeNoteImagesStyle>
      ) : (
        <CafeNoteCardsSliderStyle>
          {cafeNotes.map((cafeNote, index) => {
            return (
              <CafeNoteCard
                key={index}
                cafeNote={cafeNote}
                link={`/user/public-cafe-notes/${cafeNote.id}`}
              />
            );
          })}
        </CafeNoteCardsSliderStyle>
      )}
    </CafeNotesStyle>
  );
};

export default CafeNotes;
